// extracted by mini-css-extract-plugin
module.exports = {"sortable":"ClipsList-modulesortable2Jq"};